// Components
import MultiAccessCheckbox from './MultiAccessCheckbox'
import Checkbox from '../../../shared/components/Checkbox'

const GlobalUserFields = ({ companyUser, isAgencyAdmin }) => (
  <div>
    <div className="from-group">
      <Checkbox name="is_admin" label="Grant admin access" isChecked={ companyUser && companyUser.is_admin } />
    </div>
    { isAgencyAdmin && <MultiAccessCheckbox companyUser={companyUser} /> }
  </div>
)
const mapStateToProps = ({ isAgencyAdmin }) => ({ isAgencyAdmin })
export default connect(mapStateToProps)(GlobalUserFields)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/forms/GlobalUserFields.js